import { Col, Row } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import Button from '../../../../../components/FormElements/Button'
import DynamicForm from '../../../../../components/FormElements/DynamicForm'
import * as Yup from 'yup'
import { message } from 'antd';
import { FaIdCard } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux'
import { setError, setMessage } from '../../../../../store/common/generalSlice'
import { useMutation } from 'react-query'
import { ApiCaller, Colors } from '../../../../../config'
import { fetchProfileData } from '../../../../../store/common/settingSlice'
import { getStatusMessage, statusCheck } from '../../../../../config/utils/StatusCheck'


const form = {
    name: 'bookingForm',
    formFields: [
        {
            name: 'condition1',
            type: 'checkbox',
            label: 'I confirm that all the business information provided is accurate and up to date.',
            width: { md: 24, sm: 24, xs: 24 },
            component: null,
            classes: '',
            icon: null,
        },
        {
            name: 'condition2',
            type: 'checkbox',
            label: <p>I have read and understand the <a href='https://mobrage.com/terms-and-conditions/' target='_blank' className='underline text-[#FAB700] hover:underline hover:text-[#FAB700]'>terms and conditions</a> of Mobrage and agree to abide by them.</p>,
            width: { md: 24, sm: 24, xs: 24 },
            component: null,
            classes: '',
            icon: null,
        },
        // {
        //     name: 'condition3',
        //     type: 'checkbox',
        //     label: <a href='https://mobrage.com/privacy-policy/' target='_blank' className='underline text-[#FAB700]'>I have read and understand the privacy policy of Mobrage and agree to abide by them.</a>,
        //     width: { md: 24, sm: 24, xs: 24 },
        //     component: null,
        //     classes: '',
        //     icon: null,
        // },
        {
            name: 'condition4',
            type: 'checkbox',
            label: 'I acknowledge that any inaccuracies in my business information may result in the suspension or removal of my profile from Mobrage.',
            width: { md: 24, sm: 24, xs: 24 },
            component: null,
            classes: '',
            icon: null,
        },
    ],
    formValidation: {
        condition1: Yup.boolean()
            .oneOf([true], 'You must accept the terms and conditions')
            .required('You must accept the terms and conditions'), // Optional, to explicitly mark it as required
        condition2: Yup.boolean()
            .oneOf([true], 'You must accept the terms and conditions')
            .required('You must accept the terms and conditions'),
        // condition3: Yup.boolean()
        //     .oneOf([true], 'You must accept the terms and conditions')
        //     .required('You must accept the terms and conditions'),
        condition4: Yup.boolean()
            .oneOf([true], 'You must accept the terms and conditions')
            .required('You must accept the terms and conditions'),
    }
}

const BusinessProof = () => {

    const { profileData } = useSelector(state => state?.setting);
    const [rejectionReason, setRejectionReason] = useState('');
    const [image, setImage] = useState(null);
    const [previewImage, setPreviewImage] = useState('')
    const imageRef = useRef(null);

    const dispatch = useDispatch();
    console.log(profileData?.userDetail)

    useEffect(() => {
        if (profileData?.userDetail) {
            if (profileData?.userDetail?.proofOfBusiness) {
                // different cases to handle for showing or not showing image based on the status.
                if (profileData?.userDetail?.status == 2) {
                    // doc is rejected
                    setRejectionReason(profileData?.userDetail?.reasonOfRejection);
                    setPreviewImage('')
                }
                else if (profileData?.userDetail?.status == 1) {
                    // doc is approved
                    setPreviewImage(profileData?.userDetail?.proofOfBusiness);
                }
                else if (profileData?.userDetail?.status == 0) {
                    // doc is pending
                    setPreviewImage(profileData?.userDetail?.proofOfBusiness);
                }
            }
        }
    }, [profileData])

    const businessVerificationMutation = useMutation(async (payload) => {
        let formData = new FormData();
        formData.append('proofOfBusiness', payload);
        let res = await ApiCaller.post('/user/service-provider/upload-document', formData);
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message || 'document upload successfully'));
                dispatch(fetchProfileData())
                setRejectionReason('')
            },
            onError: (error) => {
                dispatch(setError(error?.response?.data?.error?.message || 'Error occured'))
            }
        }
    )

    const handleSubmit = (values) => {
        const { userDetail } = profileData || {};

        if (userDetail?.proofOfBusiness || !image) {
            if (!image) dispatch(setError('image is required'));
            else if (userDetail?.status == 2) {
                businessVerificationMutation.mutate(image);
                return
            }
            return;
        }

        if (typeof image === 'object') {
            console.log(image)
            businessVerificationMutation.mutate(image);
        }
    };

    const submitForm = () => {
        document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    const fileHandler = (e) => {
        if (e.target.files && !e.target.files[0]?.type?.startsWith('image/')) {
            dispatch(setError('Only image is allowed'))
            return
        }
        else if (e.target.files[0]) {
            const url = URL.createObjectURL(e.target.files[0]);
            setPreviewImage(url)
            setImage(e.target.files[0])
        }
        else {
            return
        }
    }

    const imageModalHandler = () => {
        if (profileData?.userDetail?.status == 1 || profileData?.userDetail?.status == 0) {
            return;
        }
        imageRef.current.click()
    }

    return (
        <Row>
            <Col
                md={{ span: 24, offset: 0 }}
                sm={{ span: 24, offset: 0 }}
                xs={{ span: 24, offset: 0 }}
                className='md:p-4 sm:p-4 p-2'
            >
                <div className='mb-2 text-center flex flex-col items-center'>
                    <h6 className='heading-6 font-bold mb-3'>Proof of Business</h6>
                    <div className='md:w-2/6 sm:w-2/5 mb-2 bg-[#f3f6f8] border border-dashed border-gray-300 h-36 cursor-pointer' onClick={imageModalHandler}>
                        {
                            !previewImage ?
                                <div className='py-2 px-4 w-full h-full flex flex-col items-center justify-center' >
                                    <div className="flex justify-center ant-upload-drag-icon mb-4">
                                        <FaIdCard className='text-3xl text-slate-400' />
                                    </div>
                                    <h6 className="heading-6 font-normal text-gray-400 ant-upload-text">Business/Trade Insurance</h6>
                                </div>
                                :
                                <div className='w-full h-full'>
                                    <img src={previewImage} className='w-full h-full object-contain' />
                                </div>
                        }
                        <input type='file' hidden onChange={fileHandler} ref={imageRef} accept="image/*" />
                    </div>
                </div>
                {

                    profileData?.userDetail?.status == 2 || profileData?.userDetail?.status == 3 ?
                        <div>
                            <DynamicForm form={form} onSubmit={handleSubmit} />
                            {
                                rejectionReason ?
                                    <div className='flex flex-col items-start gap-1 mb-3'>
                                        <p className='text-black'>
                                            your document has been rejected for the following reason:
                                        </p>
                                        <p className='text-red-500'>{rejectionReason}</p>
                                    </div>
                                    : ''
                            }
                            <Button.Basic
                                onClick={submitForm}
                                disabled={profileData?.userDetail?.status == 1 ? true : false}
                                icon={null}
                                loading={businessVerificationMutation.isLoading}
                                type="primary"
                                size='medium'
                                text={profileData?.userDetail?.status == 2 ? 'Resubmit' : 'Save'}
                                className='w-36 h-10 mt-3 rounded-md outline-none border-none'
                                style={{ background: Colors.AppYellow, color: 'white' }}
                            />
                        </div>
                        :
                        <div className='flex items-start gap-3 flex-col'>
                            <div className='flex gap-3 items-center'>
                                <img src={statusCheck(profileData?.userDetail?.status)} className='w-8 h-8 lg:w-16 lg:h-16' />
                                <p className='text-base font-semibold'>
                                    {getStatusMessage(profileData?.userDetail?.status)}
                                </p>
                            </div>
                            <p className='text-[#fab700] text-base'>{profileData?.userDetail?.status == 0 && 'Note: document will be verified upto 24 hrs'}</p>
                            <div>
                                {
                                    rejectionReason ?
                                        <div className='flex flex-col items-start gap-1 mb-3'>
                                            <p className='text-black'>
                                                your document has been rejected for the following reason:
                                            </p>
                                            <p className='text-red-500'>{rejectionReason}</p>
                                        </div>
                                        : ''
                                }
                            </div>
                        </div>
                }

            </Col>
        </Row>
    )
}

export default BusinessProof